(function(){
  if (window.__brootDS) return; window.__brootDS = true;
  var R = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  R.classList.add('bx-js');

  /* Page bodies carry a fallback <style>@import broot-ds.css</style> so they still
     render if the theme has not been published yet. When the theme IS serving the
     design system, that fallback is a stale duplicate sitting later in the cascade —
     disable it so the theme's current stylesheet wins. */
  function dedupeCss(){
    if (!document.querySelector('link[href*="broot-ds.css"]')) return;
    Array.prototype.forEach.call(document.querySelectorAll('style'), function(s){
      if ((s.textContent || '').indexOf('broot-ds.css') > -1 && s.sheet) {
        try { s.sheet.disabled = true; } catch (e) {}
      }
    });
  }
  dedupeCss();

  /* Full-bleed: pull .bx-page out of whatever container the theme wrapped it in.
     Works for centred page templates and off-centre article templates alike. */
  function fullBleed(){
    var els = document.querySelectorAll('.bx-page');
    if (!els.length) return;
    Array.prototype.forEach.call(els, function(el){
      el.style.setProperty('margin-left','0','important');
      el.style.setProperty('margin-right','0','important');
      el.style.setProperty('width','auto','important');
      el.style.setProperty('max-width','none','important');
      var docW = R.clientWidth;
      var r = el.getBoundingClientRect();
      el.style.setProperty('margin-left', (-r.left) + 'px', 'important');
      var r2 = el.getBoundingClientRect();
      var overhang = (r2.left + r2.width) - docW;
      el.style.setProperty('margin-right', overhang + 'px', 'important');
    });
  }
  fullBleed();

  function splitLines(el){
    if (el.dataset.bxSplit) return; el.dataset.bxSplit = '1';
    var words = (el.textContent || '').trim().split(/\s+/);
    if (!words.length) return;
    el.textContent = '';
    words.forEach(function(w, i){
      var s = document.createElement('span');
      s.className = 'bx-w';
      s.textContent = w + (i < words.length - 1 ? ' ' : '');
      el.appendChild(s);
    });
    var kids = Array.prototype.slice.call(el.children);
    var lines = [], cur = [], top = null;
    kids.forEach(function(k){
      var t = k.offsetTop;
      if (top === null) top = t;
      if (Math.abs(t - top) > 3){ lines.push(cur); cur = []; top = t; }
      cur.push(k);
    });
    if (cur.length) lines.push(cur);
    el.textContent = '';
    lines.forEach(function(ln){
      var outer = document.createElement('span'); outer.className = 'bx-line';
      var inner = document.createElement('span');
      inner.textContent = ln.map(function(k){ return k.textContent; }).join('');
      outer.appendChild(inner);
      el.appendChild(outer);
    });
  }

  var io = null;
  function markIn(el){ el.classList.add('bx-in'); }
  function initReveal(root){
    var els = (root || document).querySelectorAll('.bx-rv:not(.bx-in), .bx-mask:not(.bx-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)){
      Array.prototype.forEach.call(els, markIn); return;
    }
    if (!io){
      io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting){ markIn(en.target); io.unobserve(en.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
    }
    Array.prototype.forEach.call(els, function(e){ io.observe(e); });
  }
  function sweep(){
    var vh = window.innerHeight;
    document.querySelectorAll('.bx-rv:not(.bx-in), .bx-mask:not(.bx-in)').forEach(function(e){
      var r = e.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) markIn(e);
    });
  }

  var stmts = [];
  function initStmt(root){
    (root || document).querySelectorAll('.bx-stmt:not([data-bx])').forEach(function(el){
      el.dataset.bx = '1';
      var words = (el.textContent || '').trim().split(/\s+/);
      el.textContent = '';
      words.forEach(function(w, i){
        var s = document.createElement('span');
        s.className = 'w'; s.textContent = w + (i < words.length - 1 ? ' ' : '');
        el.appendChild(s);
      });
      stmts.push(el);
    });
  }
  function runStmt(){
    if (reduce) return;
    var vh = window.innerHeight;
    stmts.forEach(function(el){
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var start = vh * 0.82, end = vh * 0.28;
      var p = (start - r.top) / (start - end);
      p = Math.max(0, Math.min(1, p));
      var ws = el.querySelectorAll('.w');
      var n = Math.round(p * ws.length);
      for (var i = 0; i < ws.length; i++) ws[i].classList.toggle('on', i < n);
    });
  }

  var px = [];
  function collect(){ px = Array.prototype.slice.call(document.querySelectorAll('[data-bx-px]')); }
  function runPx(){
    if (reduce) return;
    var vh = window.innerHeight;
    px.forEach(function(img){
      var host = img.parentElement; if (!host) return;
      var r = host.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      var s = (parseFloat(img.getAttribute('data-bx-px')) || 0) / 100;
      img.style.transform = 'translate3d(0,' + (p * s * 100).toFixed(2) + 'px,0)';
    });
  }

  function initCount(root){
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = (root || document).querySelectorAll('[data-bx-count]:not([data-bx-done])');
    if (!els.length) return;
    var o = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target; o.unobserve(el); el.dataset.bxDone = '1';
        var raw = el.getAttribute('data-bx-count');
        var target = parseFloat(raw); if (isNaN(target)) return;
        var pre = el.getAttribute('data-bx-pre') || '';
        var post = el.getAttribute('data-bx-post') || '';
        var dec = (raw.split('.')[1] || '').length;
        var t0 = null, dur = 1400;
        function step(ts){
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          var e2 = 1 - Math.pow(1 - p, 3);
          var v = target * e2;
          el.textContent = pre + (dec ? v.toFixed(dec) : Math.round(v).toLocaleString('en-IN')) + post;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    Array.prototype.forEach.call(els, function(e){ o.observe(e); });
  }

  function initMagnet(){
    if (reduce || !window.matchMedia('(hover:hover)').matches) return;
    document.querySelectorAll('.bx-btn:not([data-bx-mag])').forEach(function(b){
      b.dataset.bxMag = '1';
      b.addEventListener('mousemove', function(e){
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.16;
        var y = (e.clientY - r.top - r.height / 2) * 0.28;
        b.style.transform = 'translate(' + x.toFixed(1) + 'px,' + (y - 2).toFixed(1) + 'px)';
      });
      b.addEventListener('mouseleave', function(){ b.style.transform = ''; });
    });
  }

  function initMarquee(root){
    (root || document).querySelectorAll('.bx-marq__t:not([data-bx])').forEach(function(t){
      t.dataset.bx = '1';
      var g = t.firstElementChild; if (!g) return;
      t.appendChild(g.cloneNode(true));
    });
  }

  var ticking = false;
  function onScroll(){
    if (ticking) return; ticking = true;
    requestAnimationFrame(function(){ runPx(); runStmt(); ticking = false; });
  }

  function boot(root){
    dedupeCss(); fullBleed();
    document.querySelectorAll('.bx-splitline:not([data-bx-split])').forEach(splitLines);
    initStmt(root); initMarquee(root); collect(); initReveal(root); initCount(root); initMagnet();
    onScroll();
  }

  function start(){ boot(document); setTimeout(function(){ dedupeCss(); fullBleed(); sweep(); }, 1200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.addEventListener('load', function(){ dedupeCss(); fullBleed(); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function(){ fullBleed(); collect(); onScroll(); }, { passive: true });
  document.addEventListener('visibilitychange', function(){ if (!document.hidden) sweep(); });
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); onScroll(); });

  window.bxQuiz = function(rootId, results){
    var root = document.getElementById(rootId); if (!root) return;
    var qs = Array.prototype.slice.call(root.querySelectorAll('.bx-quiz__q'));
    var bar = root.querySelector('.bx-quiz__bar i');
    var score = {}, step = 0;
    function show(i){
      qs.forEach(function(q, n){ q.classList.toggle('is-on', n === i); });
      if (bar) bar.style.width = Math.round((i / qs.length) * 100) + '%';
    }
    function finish(){
      var best = null, bestV = -1;
      Object.keys(score).forEach(function(k){ if (score[k] > bestV){ bestV = score[k]; best = k; } });
      var r = results[best] || results[Object.keys(results)[0]];
      var out = root.querySelector('.bx-quiz__result');
      out.innerHTML = '<p class="bx-kicker">Your coffee</p><h2 class="bx-h2">' + r.name + '</h2><p class="bx-lede bx-mt2">' + r.why + '</p><div class="bx-btns"><a class="bx-btn" href="' + r.url + '">Shop ' + r.name + ' <span class="bx-arw">&rarr;</span></a><a class="bx-btn bx-btn--ghost" href="/collections/all-coffees">See everything</a></div>';
      qs.forEach(function(q){ q.classList.remove('is-on'); });
      out.classList.add('is-on');
      if (bar) bar.style.width = '100%';
      initMagnet();
    }
    root.querySelectorAll('.bx-opt').forEach(function(b){
      b.addEventListener('click', function(){
        (b.getAttribute('data-v') || '').split(',').forEach(function(k){
          k = k.trim(); if (k) score[k] = (score[k] || 0) + 1;
        });
        step++;
        if (step >= qs.length) finish(); else show(step);
      });
    });
    show(0);
  };
})();
